import { Button } from "components/atoms/button/button";
import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) => theme.colors.blue[800]};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 20px;
  padding: 40px 32px 40px 32px;
  text-align: center;
  gap: 32px;
`;

export const ModalHeader = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2hxl"]};
  line-height: 40px;
  color: ${({ theme }) => theme.colors.yellow[500]};
  margin: 0;
`;

export const ModalSubHeader = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.white};
  margin: 4px 0 12px 0;
  font-weight: 400;
  line-height: 24px;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
`;

export const ImageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 50px;
`;

export const IllustrationWrapper = styled.div`
  width: 100%;
  height: auto;
  border-radius: 16px 16px 0 0;
`;

export const ContentBox = styled.div`
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.neutral[900]};
  border-radius: 16px;
  padding: 24px;
  width: 328px;
  text-align: center;
  margin-top: -77px;
  z-index: 2;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
`;

export const ContentTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral[1000]};
  margin: 0;
`;

export const ContentSubtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral[700]};
  margin: 4px 0 12px 0;
  font-weight: 400;
  line-height: 24px;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
`;

export const SelectScheduleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding: 13px 24px 13px 24px;
  gap: 8px;
`;
export const SelectScheduleCTA = styled(Button)`
  width: 100%;
  border-radius: 6px;
  gap: 8px;
`;
